<script>
import appConfig from "@/app.config";
export default {
    props: {
        showLoadingScreen: Boolean,
        page: String
    },
//   name: "VideoPlayer",
//    computed: {
//     videoElement () {
//       return this.$refs.video;
//     }, 
//   },
    data: () => ({
        assetsPath: appConfig.assetsPath,
        // gif1: 'http://drpanda.surge.sh/img/CN-logo-animation-source-mov-1080p4.74b43dcf.gif',
        // gif2: 'http://drpanda.surge.sh/img/CN-logo-animation-source-mov-1080p5.cbaf6c79.gif',
        gif1: 'panda-loading-photo.gif',
        gif2: 'CN-logo-animation-source-mov-1080p5-540p.gif',
        showFullLoading: false,
        first: true,
        second: false,

    }),
    created() {     
        //this.showFullLoading = true;
        // if (this.page === 'home') {
        //     this.first = false;
        //     this.second = true;
        // } else {
        //     this.first = true;
        //     this.second = false;
        // }
        console.log('showLoadingScreen >', this.showLoadingScreen)
        this.showFullLoading = this.showLoadingScreen;
    },
    mounted() {
        // this.videoElement.video;
        
    },
    watch: { 
        showLoadingScreen(newVal) { // watch it
            // if (!newVal && this.page == 'home') {
            //     this.first = false;
            //     this.second = true;
            //     //this.gif2 = this.gif2 + '?' + 'v1';
            //     setTimeout(() => {
            //         this.showFullLoading = false;
            //     }, 8000);
            // } else {
            //     this.showFullLoading = false;
            // }

            this.showFullLoading = false;
        }
    },
    methods: {
        getImgUrl(img, second) {
            //let url = require("@/assets/images/" + img);
            let url = this.assetsPath + 'images/' + img;
            if (second) {
                url = url  + '?' + 'v1';
            }
            return url;
        },
    }
}
</script>
<template>
        <transition name="fade">
            <div :class="$style.loadingBlock" v-if="false">
                <img :src="getImgUrl(gif1)" alt="" :class="$style.gif" autoplay="false" v-if="first"/>
                <img :src="getImgUrl(gif2, second)" alt="" :class="[$style.gif_home, second ? $style.show : '']" />
                <!-- <img :src="gif1" alt="" :class="$style.gif" autoplay="false" v-if="first"/>
                <img :src="gif2" alt="" :class="[$style.gif_home, second ? $style.show : '']" /> -->
                

        <!--           
                <div :class="$style.videoPlayer">
                    <video controls>
                        <source src="@/assets/CN logo animation source-mov 1080p5.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div> -->
            </div>
    </transition>
</template>

<style lang="scss" module>
    .loadingBlock{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100vh;
        z-index: 9999;
        background-color: #fff;
        overflow: hidden;
        .gif{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 1100px;
        }
        .gif_home{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 1100px;
            visibility: hidden;
            &.show{
                visibility: visible;
            }
        }
        .videoPlayer{
            width: 1100px;
            video{
                width: 100%;
                background: #fff;
            }
            
        }
    }

</style>